import { createContext, useContext, useEffect, useMemo, useState } from 'react';

import { PRODUCT_CATEGORIES } from '../utils/constants';

import { useApp } from './AppContext';

const ProductContext = createContext(null);

export const ProductProvider = ({ children }) => {
  const { appContent } = useApp();

  const [allProducts, setAllProducts] = useState([]);
  const [productsDetails, setProductsDetails] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productId, setProductId] = useState(null);
  const [activeCategory, setActiveCategory] = useState(PRODUCT_CATEGORIES.highlights.key);

  useEffect(() => {
    if (appContent) {
      setAllProducts([...appContent?.posts, ...appContent?.guides, ...appContent?.products]);
    }
  }, [appContent]);

  const product = useMemo(() => allProducts.find(item => item.id === productId), [allProducts, productId]);

  const productDetails = useMemo(
    () =>
      productsDetails.find(item => item.post_id === productId) || {
        comments: [],
        is_liked: false,
        is_shared: false,
        likes: [],
        post_id: productId,
        shares: [],
      },
    [productsDetails, productId],
  );

  const value = {
    allProducts,
    setAllProducts,
    productsDetails,
    setProductsDetails,
    selectedProduct,
    setSelectedProduct,
    productId,
    setProductId,
    activeCategory,
    setActiveCategory,
    product,
    productDetails,
  };

  return <ProductContext.Provider value={value}>{children}</ProductContext.Provider>;
};

export const useProduct = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error('useProduct must be used within a ProductProvider');
  }
  return context;
};
